import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { RamadanProvider } from './context/RamadanContext';
import { LanguageProvider } from './context/LanguageContext';
import { StartDateProvider } from './context/StartDateContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import SummaryPage from './pages/SummaryPage';
import StartDateSelector from './components/StartDateSelector';
import { useStartDate } from './context/StartDateContext';
import UpdateNotification from './components/UpdateNotification';
import OfflinePage from './components/OfflinePage';
import { Workbox } from 'workbox-window';
import './index.css';

// Wrapper component to conditionally render the main content
const MainContent: React.FC = () => {
  const { isDateSelected } = useStartDate();
  
  return (
    <>
      {isDateSelected ? (
        <>
          <Navbar />
          <main className="pb-20 md:pb-0">
            <Routes>
              <Route path="/" element={<HomePage />} />
              {/* <Route path="/summary" element={<SummaryPage />} /> */}
              <Route path="/bn" element={<HomePage />} />
            </Routes>
          </main>
          <Footer />
        </>
      ) : (
        <>
          <StartDateSelector />
          <Footer />
        </>
      )}
    </>
  );
};

// Define props interface for App component
interface AppProps {
  serviceWorker: Workbox | null;
}

function App({ serviceWorker }: AppProps) {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);
  const [showOfflineBanner, setShowOfflineBanner] = useState<boolean>(false);

  useEffect(() => {
    // Event listeners for online/offline status
    const handleOnline = () => {
      setIsOnline(true);
      // Show a temporary banner that we're back online
      setShowOfflineBanner(true);
      setTimeout(() => setShowOfflineBanner(false), 3000);
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Display offline page when user is offline
  if (!isOnline) {
    return <OfflinePage />;
  }

  return (
    <Router>
      <LanguageProvider>
        <StartDateProvider>
          <RamadanProvider>
            <div className="min-h-screen bg-background-light flex flex-col">
              <UpdateNotification />
              
              {showOfflineBanner && (
                <div className="bg-green-600 text-white text-center py-2 px-4 fixed top-0 left-0 right-0 z-50">
                  You're back online!
                </div>
              )}
              
              <div className="flex-grow">
                <MainContent />
              </div>
            </div>
          </RamadanProvider>
        </StartDateProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;
